import React, { useEffect, useState } from 'react';
import { Header } from '../../components/Header/Header';
import { Footer } from '../../components/Footer/Footer';
import { EventsSection, AulasSection, ExposicaoSection } from '../../components/sections';
import { GetUpcomingEventsUseCase } from '../../../application/use-cases/GetUpcomingEventsUseCase';
import { GetAulasUseCase } from '../../../application/use-cases/GetAulasUseCase';
import { GetOrganizationInfoUseCase } from '../../../application/use-cases/GetOrganizationInfoUseCase';
import { GetVisitasGuiadasUseCase } from '../../../application/use-cases/GetVisitasGuiadasUseCase';
import { Event } from '../../../domain/entities/Event';
import { Aula } from '../../../domain/entities/Aula';
import { Organization } from '../../../domain/entities/Organization';
import { VisitaGuiada } from '../../../domain/entities/VisitaGuiada';
import { GoogleSheetsEventRepositoryImpl } from '../../../infrastructure/repositories/GoogleSheetsEventRepositoryImpl';
import { GoogleSheetsAulaRepositoryImpl } from '../../../infrastructure/repositories/GoogleSheetsAulaRepositoryImpl';
import { OrganizationRepositoryImpl } from '../../../infrastructure/repositories/OrganizationRepositoryImpl';
import { GoogleSheetsVisitaGuiadaRepositoryImpl } from '../../../infrastructure/repositories/GoogleSheetsVisitaGuiadaRepositoryImpl';
import pandeiroBg from '../../../assets/pandeiro.webp';
import './LandingPage.css';

export const LandingPage: React.FC = () => {
  const [events, setEvents] = useState<Event[]>([]);
  const [aulas, setAulas] = useState<Aula[]>([]);
  const [organization, setOrganization] = useState<Organization | null>(null);
  const [loading, setLoading] = useState(true);
  const [visitas, setVisitas] = useState<VisitaGuiada[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const eventRepository = new GoogleSheetsEventRepositoryImpl();
        const aulaRepository = new GoogleSheetsAulaRepositoryImpl();
        const organizationRepository = new OrganizationRepositoryImpl();
        const visitaRepository = new GoogleSheetsVisitaGuiadaRepositoryImpl();
        
        const getEventsUseCase = new GetUpcomingEventsUseCase(eventRepository);
        const getAulasUseCase = new GetAulasUseCase(aulaRepository);
        const getOrganizationUseCase = new GetOrganizationInfoUseCase(organizationRepository);
        const getVisitasUseCase = new GetVisitasGuiadasUseCase(visitaRepository);

        const [eventsData, aulasData, organizationData, visitasData] = await Promise.all([
          getEventsUseCase.execute(),
          getAulasUseCase.execute(),
          getOrganizationUseCase.execute(),
          getVisitasUseCase.execute()
        ]);

        setEvents(eventsData);
        setAulas(aulasData);
        setOrganization(organizationData);
        setVisitas(visitasData);
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Carregando Casa do Pandeiro...</p>
      </div>
    );
  }

  const landingPageStyle = {
    backgroundImage: `url(${pandeiroBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed'
  };

  const handleContact = () => {
    window.location.href = 'mailto:contato@casadopandeiro.com';
  };

  return (
    <div className="landing-page" style={landingPageStyle}>
      {organization && <Header organization={organization} />}
      
      <div className="main-content">
        <div className="sections-grid">
          {/* Exposição em largura total no topo */}
          <div className="section-full-width">
            <ExposicaoSection visitas={visitas} />
          </div>
          
          {/* Aulas e Eventos lado a lado */}
          <div className="section-half-width">
            <AulasSection aulas={aulas} />
          </div>
          
          <div className="section-half-width">
            <EventsSection events={events} />
          </div>
        </div>
      </div>
      
      <Footer onContact={handleContact} />
    </div>
  );
}; 